module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_7042.3b40e711.png";